import VersionCompareKeyValueGrid from 'components/v2/compiler/version-compare/VersionCompareKeyValueGrid';
import { VersionCompareRow } from 'components/v2/compiler/version-compare/VersionCompareRow';
import { EpdVersionHistoryData } from 'components/v2/compiler/version-history/utils/EpdVersionHistoryDataContext';
import { ImagesUpload } from 'components/v2/images-upload';
import SmartLabel from 'components/v2/labels/SmartLabel';
import React from 'react';
import { FieldPanelHeader } from 'styles/v2/Styles.styled';
import ComparePanelComponent from '../../../../pages/v2/compiler/ComparePanelComponent';
import { getProductInformationGridRows } from '../version-history/content/VersionHistoryProductInformationGrid';
import { mergeToLeftRightByIndex } from './utils/mergers';

const CompareProductsSection: React.FC<{
  data: { left: EpdVersionHistoryData | null; right: EpdVersionHistoryData | null };
}> = ({ data }) => {
  const mergedProductsInformation = mergeToLeftRightByIndex(data.left?.productsInformation, data.right?.productsInformation);

  return (
    <>
      {mergedProductsInformation.map((pair) => (
        <ComparePanelComponent key={pair.left?.id || pair.right?.id}>
          <VersionCompareRow data={pair} displayCondition={(x) => !!x}>
            {({ item }) => (
              <FieldPanelHeader>
                {item?.productName ? `Product information - ${item.productName}` : 'Product information'}
              </FieldPanelHeader>
            )}
          </VersionCompareRow>

          <VersionCompareKeyValueGrid isLeft={true} additionalData={pair} rowsGetter={getProductInformationGridRows} />
          <VersionCompareKeyValueGrid isLeft={false} additionalData={pair} rowsGetter={getProductInformationGridRows} />

          <VersionCompareRow
            data={pair}
            displayCondition={(x) => !!x}
            compareBy={(item) => item?.productDetailsImages?.map((f) => f.name).join(',')}
          >
            {({ item, compareClassName }) => (
              <div>
                <SmartLabel label="Product images" />
                <ImagesUpload
                  className={compareClassName}
                  name="ProductImages"
                  images={item.productDetailsImages}
                  onUpload={() => {}}
                  onReorder={() => {}}
                  onRemove={() => {}}
                  disabled
                  preferEnabledAppearanceEvenWhenDisabled
                />
              </div>
            )}
          </VersionCompareRow>
        </ComparePanelComponent>
      ))}
    </>
  );
};

export default CompareProductsSection;
